// src/components/StatsCard.jsx
import React, { useState, useEffect } from 'react';
import '../styles/StatsCard.css';

export default function StatsCard({ label, value, highlight, loading = false, animationDelay = 0 }) {
  const [isAnimating, setIsAnimating] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (!loading && value !== undefined && !hasLoaded) {
      // Trigger animation when loading completes for the first time
      setHasLoaded(true);
      const timer = setTimeout(() => {
        setIsAnimating(true);
        const animTimer = setTimeout(() => setIsAnimating(false), 800);
        return () => clearTimeout(animTimer);
      }, animationDelay);
      return () => clearTimeout(timer);
    }
  }, [loading, value, hasLoaded, animationDelay]);

  if (loading) {
    return (
      <div className={`stats-card stats-card--loading${highlight ? ' stats-card--highlight' : ''}`}>
        <div className="stats-card__skeleton stats-card__skeleton--value"></div>
        <div className="stats-card__skeleton stats-card__skeleton--label"></div>
      </div>
    );
  }

  return (
    <div 
      className={`stats-card${highlight ? ' stats-card--highlight' : ''}${isAnimating ? ' stats-card--animating' : ''}${hasLoaded ? ' stats-card--loaded' : ''}`}
      style={{ 
        '--animation-delay': `${animationDelay}ms`,
        '--stagger-delay': `${animationDelay}ms`
      }}
    >
      <div className="stats-card__content">
        <div className="stats-card__value">{value}</div>
        <div className="stats-card__label">{label}</div>
      </div>
    </div>
  );
}
